import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Button from "@civicplus/preamble-ui/lib/Button";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideoStreamIcon from "mdi-material-ui/VideoWireless";
import { makeFullUrl } from "../../utils";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

interface EventVideoButtonProps {
  eventId: number;
  externalMediaUrl?: string;
  isLive?: boolean;
  className?: string;
  disabled?: boolean;
}

const EventVideoButton: React.FC<EventVideoButtonProps> = ({
  eventId,
  externalMediaUrl,
  isLive,
  className,
  disabled,
}) => {
  const portalCustomization = useSelector(
    (state: RootState) => state.portalCustomization
  );

  const renderedButtonProps: {
    href?: React.ComponentProps<typeof Button>["href"];
    openInNewWindow?: React.ComponentProps<typeof Button>["openInNewWindow"];
    component?: React.ComponentProps<typeof Button>["component"];
    to?: React.ComponentProps<typeof RouterLink>["to"];
  } = {};

  // If the component is embedded, use anchor element/href, else use RouterLink/to
  if (externalMediaUrl) {
    renderedButtonProps.href = externalMediaUrl;
    renderedButtonProps.openInNewWindow = true;
  } else if (process.env.REACT_APP_EMBED) {
    renderedButtonProps.href = makeFullUrl(`/event/${eventId}/media`);
    renderedButtonProps.openInNewWindow = true;
  } else {
    renderedButtonProps.component = RouterLink;
    renderedButtonProps.to = `event/${eventId}/media`;
  }

  return (
    <Button
      {...renderedButtonProps}
      {...(portalCustomization?.enablePublicSpeakerSignup
        ? { variant: "text", disabled: disabled }
        : { type: "icon" })}
      title={
        disabled
          ? undefined
          : isLive
          ? "Go to Event Live Stream"
          : "Go To Event Media"
      }
      TooltipProps={{ placement: "left" }}
      stopPropagation={true}
      onMouseDown={(e: React.MouseEvent<Element, MouseEvent>) =>
        e.stopPropagation()
      }
      color="primary"
      className={className}
    >
      {isLive ? <VideoStreamIcon /> : <VideocamIcon />}
      {portalCustomization?.enablePublicSpeakerSignup && "Media"}
    </Button>
  );
};

export default EventVideoButton;
